import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IDevice } from '@lib/axon/interfaces/device.interface';

@Component({
  selector: 'fs-axon-cam-feed-card',
  templateUrl: './axon-cam-feed-card.component.html',
  styleUrls: ['./axon-cam-feed-card.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'fs-axon-cam-feed-card',
  },
})
export class AxonCamFeedCardComponent implements OnInit {
  @Input()
  public device: IDevice;

  @Input()
  public actions = true;

  @Output()
  public readonly closeDockedCamera = new EventEmitter<any>();

  constructor() {}

  public ngOnInit(): void {}

  public closeCamera(): void {
    this.closeDockedCamera.next();
  }
}
